// Phase 2.5 — "Manage existing access" panel extracted from
// GrantAccessModal.jsx. Shows the existing portal user's metadata + Revoke
// and Re-issue actions side by side. Pure presentational; parent owns the
// async handlers.

import { Btn, Badge } from "@/components/Shared";
import { Check, KeyRound, Mail } from "lucide-react";

export default function GrantExistingPanel({
  role,
  existing,
  busy,
  onClose,
  onRevoke,
  onReissue,
}) {
  return (
    <div className="space-y-4" data-testid="grant-existing-block">
      <div className="rounded-sm border border-emerald-200 bg-emerald-50/60 px-4 py-3">
        <div className="text-[11px] uppercase tracking-[0.18em] font-semibold text-emerald-800 flex items-center gap-1.5 mb-1.5">
          <Check size={12} strokeWidth={2.4} />
          Access already granted
        </div>
        <div className="text-[13px] text-[var(--ink)]">
          <b>{existing.name || existing.email}</b>{" "}
          <span className="text-[var(--muted)]">·</span>{" "}
          <code className="text-[12px] bg-white px-1.5 py-0.5 rounded-sm border border-emerald-200">{existing.email}</code>
        </div>
        <div className="mt-1 text-[11.5px] text-[var(--muted)] flex flex-wrap gap-x-3 gap-y-0.5">
          {existing.created_at && <span>Created {new Date(existing.created_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</span>}
          {existing.last_login_at
            ? <span>Last sign-in {new Date(existing.last_login_at).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}</span>
            : <span>Never signed in</span>}
          {existing.must_change_password && <Badge tone="warning">Must change password</Badge>}
        </div>
      </div>
      <div className="text-[12.5px] text-[var(--muted)] leading-relaxed">
        <b className="text-[var(--ink)]">Re-issue credentials</b> generates a fresh temporary password and emails it to <code className="text-[11.5px] bg-[var(--surface-2)] px-1 py-0.5 rounded-sm">{existing.email}</code>. The user keeps their account and history.<br />
        <b className="text-[var(--ink)]">Revoke</b> deletes their portal account entirely — use this if the user has left, or if you need to re-issue access to a different email address. The linked {role} record is unaffected.
      </div>
      <div className="flex flex-wrap items-center justify-end gap-2 pt-2">
        <Btn variant="ghost" onClick={onClose} testid="grant-existing-cancel">Close</Btn>
        <Btn variant="danger" onClick={onRevoke} disabled={busy} testid="grant-existing-revoke">
          <KeyRound size={13} /> Revoke
        </Btn>
        <Btn variant="primary" onClick={onReissue} disabled={busy} testid="grant-existing-reissue">
          {busy ? "Working…" : (<><Mail size={13} /> Re-issue credentials</>)}
        </Btn>
      </div>
    </div>
  );
}
